import type { RootState } from 'state';
import type { RoutesFiltersOptionsState } from '../slice';

function getAirportsFrom(state: RootState): RoutesFiltersOptionsState['airportsFrom'] {
  const { airportsFrom } = state.flightRoutes.filtersOptions;
  return airportsFrom;
}

export default getAirportsFrom;
